import { useState, useEffect, useRef } from 'react';
import { IoArrowBackCircle, IoArrowForwardCircle } from 'react-icons/io5';
import { FilePreview } from '../../../Utils/filePreview';

const FilePreviewCarousel = ({ allDocUrls, docIndex, setDocIndex, t }) => {
    const [startIndex, setStartIndex] = useState(0);
    const [isCompact, setIsCompact] = useState(
        () => typeof window !== 'undefined' && window.matchMedia('(max-width: 1200px)').matches
    );
    const scrollRef = useRef(null);
    const visibleFiles = 3;
    const totalFiles = allDocUrls.length;
    const thumbSize = isCompact ? 56 : 72;
    const thumbTrail = isCompact ? 44 : 56;

    const handleScrollLeft = () => {
        if (startIndex > 0) setStartIndex(startIndex - 1);
    };

    const handleScrollRight = () => {
        if (startIndex + visibleFiles < totalFiles) setStartIndex(startIndex + 1);
    };

    useEffect(() => {
        const mq = window.matchMedia('(max-width: 1200px)');
        const onChange = (e) => setIsCompact(e.matches);
        setIsCompact(mq.matches);
        mq.addEventListener?.('change', onChange);
        return () => mq.removeEventListener?.('change', onChange);
    }, []);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'ArrowLeft') handleScrollLeft();
            if (event.key === 'ArrowRight') handleScrollRight();
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [startIndex]);

    return (
        <div
            className="file-carousel-container"
            style={{
                marginBottom: 6,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 6,
                width: '100%',
                overflow: 'hidden',
                position: 'relative',
                flex: '0 0 auto',
            }}
        >
            {startIndex + visibleFiles < totalFiles && (
                <IoArrowForwardCircle
                    size={isCompact ? 28 : 34}
                    color="#304FFF"
                    onClick={handleScrollRight}
                    style={{ cursor: 'pointer', flexShrink: 0 }}
                />
            )}
            <div
                ref={scrollRef}
                style={{
                    display: 'flex',
                    gap: 6,
                    overflow: 'hidden',
                    width: 'min(100%, 280px)',
                    position: 'relative',
                }}
            >
                {allDocUrls.slice(startIndex, startIndex + visibleFiles + 1).map((fileUrl, idx) => (
                    <div
                        key={startIndex + idx}
                        onClick={() => setDocIndex(startIndex + idx)}
                        style={{
                            cursor: 'pointer',
                            opacity: idx === visibleFiles ? 0.5 : (startIndex + idx === docIndex ? 1 : 0.85),
                            transform: idx === visibleFiles ? 'scale(0.9)' : 'scale(1)',
                            transition: 'opacity 0.3s ease, transform 0.3s ease',
                            outline: startIndex + idx === docIndex ? '2px solid #304FFF' : 'none',
                            borderRadius: 4,
                            flexShrink: 0,
                        }}
                    >
                        <FilePreview
                            fileUrl={fileUrl}
                            t={t}
                            openPreview={() => setDocIndex(startIndex + idx)}
                            width={idx === visibleFiles ? thumbTrail : thumbSize}
                            height={idx === visibleFiles ? thumbTrail : thumbSize}
                        />
                    </div>
                ))}
            </div>

            {startIndex + visibleFiles < totalFiles && (
                <div
                    style={{
                        position: 'absolute',
                        right: 36,
                        top: 0,
                        bottom: 0,
                        width: 36,
                        background: 'linear-gradient(to right, rgba(248,249,252,0), rgba(248,249,252,1))',
                        pointerEvents: 'none',
                    }}
                />
            )}

            {startIndex > 0 && (
                <IoArrowBackCircle
                    size={isCompact ? 28 : 34}
                    color="#304FFF"
                    onClick={handleScrollLeft}
                    style={{ cursor: 'pointer', flexShrink: 0 }}
                />
            )}
        </div>
    );
};

export default FilePreviewCarousel;
